/* MCR announcement bar: rotation (per-breakpoint mode), pause control, live countdowns. */
(function () {
  'use strict';
  if (customElements.get('mcr-announcement')) return;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  class McrAnnouncement extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.items = Array.prototype.slice.call(this.querySelectorAll('.mcr-ann__list:not(.mcr-ann__list--clone) > .mcr-ann__item'));
      this.mq = window.matchMedia('(min-width: 750px)');
      this.interval = Math.max(2500, parseInt(this.getAttribute('data-interval'), 10) || 5000);
      this.index = 0;
      this.style.setProperty('--mcr-ann-interval', this.interval + 'ms');
      this.paused = false;
      this.hovering = false;
      // hold the first message until the visitor engages (see MCRWhenEngaged in layout/theme.liquid)
      this.waiting = !!window.MCRWhenEngaged;
      if (this.waiting) {
        var selfA = this;
        this.classList.add('is-waiting');
        window.MCRWhenEngaged(function () { selfA.waiting = false; selfA.classList.remove('is-waiting'); });
      }
      if (this.items[0]) this.items[0].classList.add('is-active');
      this.classList.add('is-ready');

      var self = this;
      this.pauseBtn = this.querySelector('[data-mcr-ann-pause]');
      if (this.pauseBtn) {
        this.pauseBtn.addEventListener('click', function () {
          self.paused = !self.paused;
          self.classList.toggle('is-paused', self.paused);
          self.pauseBtn.setAttribute('aria-pressed', self.paused ? 'true' : 'false');
        });
      }
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-mcr-ann-go]'));
      this.dots.forEach(function (d) {
        d.addEventListener('click', function () { self.show(parseInt(d.getAttribute('data-mcr-ann-go'), 10)); self.sync(); });
      });
      this.querySelectorAll('[data-mcr-ann-prev], [data-mcr-ann-next]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.hasAttribute('data-mcr-ann-next') ? 1 : -1;
          self.show((self.index + dir + self.items.length) % self.items.length);
          self.sync();
        });
      });
      var hold = function () { self.hovering = true; };
      var release = function () { self.hovering = false; };
      this.addEventListener('pointerenter', hold);
      this.addEventListener('pointerleave', release);
      this.addEventListener('focusin', hold);
      this.addEventListener('focusout', release);
      if (this.mq.addEventListener) this.mq.addEventListener('change', function () { self.sync(); });
      this.sync();
      this.initCountdowns();

      document.addEventListener('shopify:block:select', function (e) {
        var i = self.items.findIndex(function (it) { return it.contains(e.target) || it === e.target; });
        if (i > -1) {
          self.show(i);
          self.hovering = true;
        }
      });
      document.addEventListener('shopify:block:deselect', release);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      clearInterval(this.cdTimer);
    }

    mode() { return this.mq.matches ? this.getAttribute('data-desktop') : this.getAttribute('data-mobile'); }

    sync() {
      clearInterval(this.timer);
      if (this.mode() === 'rotate' && this.items.length > 1) {
        var self = this;
        this.timer = setInterval(function () {
          if (self.waiting || self.paused || self.hovering || document.hidden) return;
          self.show((self.index + 1) % self.items.length);
        }, this.interval);
      }
    }

    show(i) {
      if (i === this.index) return;
      var cur = this.items[this.index];
      var next = this.items[i];
      if (!next) return;
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      setTimeout(function () { cur.classList.remove('is-leaving'); }, 650);
      next.classList.add('is-active');
      this.index = i;
      if (this.dots) this.dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }

    initCountdowns() {
      var nodes = Array.prototype.slice.call(this.querySelectorAll('[data-mcr-countdown]'));
      if (!nodes.length) return;
      var list = nodes
        .map(function (el) {
          var t = Date.parse(el.getAttribute('data-mcr-countdown')); // ISO 8601 with offset — safe in Safari
          if (isNaN(t)) {
            el.hidden = true;
            return null;
          }
          return { el: el, end: t, units: (el.getAttribute('data-units') || 'd,h,m,s').split(','), expired: el.getAttribute('data-expired') || '' };
        })
        .filter(Boolean);
      if (!list.length) return;
      var tick = function () {
        var now = Date.now();
        var live = 0;
        list.forEach(function (c) {
          var diff = Math.max(0, Math.floor((c.end - now) / 1000));
          if (!diff) {
            var item = c.el.closest('.mcr-ann__msg');
            var text = item && item.querySelector('.mcr-ann__text');
            if (text && c.expired) text.textContent = c.expired;
            c.el.textContent = '';
            return;
          }
          live++;
          var d = Math.floor(diff / 86400);
          var h = Math.floor((diff % 86400) / 3600);
          var m = Math.floor((diff % 3600) / 60);
          var s = diff % 60;
          var u = c.units;
          var out = (d ? d + (u[0] || 'd') + ' ' : '') + pad(h) + (u[1] || 'h') + ' ' + pad(m) + (u[2] || 'm') + ' ' + pad(s) + (u[3] || 's');
          if (c.el.textContent !== out) c.el.textContent = out;
        });
        if (!live) clearInterval(this.cdTimer);
      }.bind(this);
      tick();
      this.cdTimer = setInterval(tick, 1000);
    }
  }

  customElements.define('mcr-announcement', McrAnnouncement);
})();
